<template>
      <div class="s_bor10 s_bor_cbed s_over_h mb25">
            <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_font_b s_bf58 s_c333 mb25">{{title}}</p>
            <div class="s_ptb0lr24">
                  <slot name="main"></slot>
            </div>
      </div>
</template>

<script>
export default {
  name:"content",
  props:{title:String}
}
</script>
<style lang="less" scoped>

</style>